import { translate } from 'shared/services/I18nService';
import {createToolbarButton} from '../../components/toolbar-button/toolbar-button-factory';

const BUTTON_CLASS = 'uscope-imagescope-launcher-button';
const BUTTON_HOVER_TEXT = 'uScope.extensions.imageScope.toolbar-icon-alt-text';

export class ImagescopeLauncher {
  constructor (uScope, downloader) {
    this._uScope = uScope;
    this._downloader = downloader;

    const button = createToolbarButton({
      context: this,

      className: BUTTON_CLASS,

      title: translate(BUTTON_HOVER_TEXT),

      onClick: this.launchImagescope
    });

    uScope.topToolbar.addButton(button);
  }

  configure (settings) {
    this._settings = settings;
    this._urlGenerator = window[settings.urlGenerator] || urlGeneratorFactory(settings.targetUrlTemplate);
  }

  launchImagescope () {
    const viewport = this._uScope.getThisImage();
    let imageId = viewport.rawImageId;

    if (imageId) {
      this._downloader.download({
        uri: this._urlGenerator(imageId),
        filename: this._settings.filename
      });
    } else {
      this._uScope.notifications.error(translate('uScope.extensions.imageScope.no-image'));
    }

    return false;
  }
}

function urlGeneratorFactory (targetUrlTemplate) {
  return function (imageId) {
    return targetUrlTemplate.replace('{IMAGE_IDS}', imageId);
  };
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/imagescope-launcher/ImagescopeLauncher.js